var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_418_1599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.978 2H2.76914C2.44278 2 2.12978 2.12965 1.899 2.36043C1.66822 2.5912 1.53857 2.9042 1.53857 3.23057V17.4394C1.53857 17.7658 1.66822 18.0788 1.899 18.3096C2.12978 18.5404 2.44278 18.67 2.76914 18.67H16.978C17.3044 18.67 17.6174 18.5404 17.8482 18.3096C18.0789 18.0788 18.2086 17.7658 18.2086 17.4394V3.23057C18.2086 2.9042 18.0789 2.5912 17.8482 2.36043C17.6174 2.12965 17.3044 2 16.978 2ZM6.50716 16.2008H4.00087V8.23967H6.50716V16.2008ZM5.25228 7.13644C4.96799 7.13484 4.69053 7.04906 4.45495 6.88993C4.21936 6.73079 4.03618 6.50544 3.92855 6.2423C3.82092 5.97916 3.79364 5.69004 3.85017 5.41141C3.9067 5.13279 4.04449 4.87716 4.24617 4.67677C4.44784 4.47639 4.70436 4.34024 4.98334 4.2855C5.26232 4.23076 5.55126 4.25989 5.8137 4.36921C6.07614 4.47854 6.30032 4.66315 6.45794 4.89976C6.61556 5.13636 6.69955 5.41436 6.69933 5.69866C6.70201 5.889 6.66634 6.07793 6.59445 6.25419C6.52257 6.43045 6.41593 6.59043 6.28089 6.7246C6.14586 6.85877 5.98519 6.96438 5.80847 7.03514C5.63175 7.1059 5.4426 7.14035 5.25228 7.13644V7.13644ZM15.7451 16.2077H13.24V11.8585C13.24 10.5758 12.6947 10.1799 11.9909 10.1799C11.2477 10.1799 10.5184 10.7402 10.5184 11.8909V16.2077H8.01209V8.24546H10.4223V9.34869H10.4547C10.6967 8.85901 11.544 8.02204 12.8371 8.02204C14.2356 8.02204 15.7463 8.85207 15.7463 11.2831L15.7451 16.2077Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_418_1599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.67,
    height: 16.67,
    fill: "white",
    transform: "translate(1.53857 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.e056275afc6b6959bc194c677837d7a2.svg";
export { ForwardRef as ReactComponent };